require('./userNotificationsSectionHeader.scss');

//@vendor
const PropTypes = require('prop-types');
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
//@utilities
const { FormattedText } = require('core/i18n').i18n;
//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

class UserNotificationsSectionHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { onFilterClick } = this.props;
        const headerTitle = (
            <div>
                <FormattedText value="userNotificationsSection-headerTitle" format="firstUppercase" />
            </div>
        );

        return (
            <header className="user-notifications-section-header">
                <div className="user-notifications-section-header__title">
                    <OKBoxTitle value={headerTitle} />
                </div>
                <div className="user-notifications-section-header__filters">
                    <OKButton modifier="task" onClick={onFilterClick}>
                        <i className="icon icon-filtrar user-notifications-section-header__filter-settings-icon" />
                    </OKButton>
                </div>
            </header>
        );
    }
}

UserNotificationsSectionHeader.propTypes = {
    onFilterClick: PropTypes.func.isRequired
}

module.exports = UserNotificationsSectionHeader;
